(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Kategori Slider (index) + Diğer Ürünlerimiz (Urun) — #references mantığıyla
  // Swiper. Slide genişliği Swiper'a bırakılır (slidesPerView + spaceBetween).
  DNB.ProductSlider = {
    init: function () {
      var roots = document.querySelectorAll("[data-pslider]");
      Array.prototype.forEach.call(roots, function (root) { setup(root); });
    }
  };

  function setup(root) {
    if (!root || root.getAttribute("data-pslider-init") === "1") return;
    root.setAttribute("data-pslider-init", "1");

    var track = root.querySelector("[data-pslider-track]");
    if (!track || !window.Swiper) return;

    var counter = root.querySelector("[data-pslider-counter]");
    var prev = root.querySelector("[data-pslider-prev]");
    var next = root.querySelector("[data-pslider-next]");

    var perView = parseFloat(root.getAttribute("data-per-view")) || 3.23;
    var space = parseInt(root.getAttribute("data-space"), 10);
    if (isNaN(space)) space = 30;

    var swiper = new window.Swiper(track, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 600,
      breakpoints: {
        768: { slidesPerView: Math.min(2.2, perView), spaceBetween: Math.min(24, space) },
        1024: { slidesPerView: perView, spaceBetween: space }
      },
      on: {
        init: update,
        slideChange: update,
        resize: update
      }
    });

    function update(sw) {
      if (counter) counter.textContent = (sw.activeIndex + 1) + " / " + sw.slides.length;
      if (prev) prev.disabled = sw.isBeginning;
      if (next) next.disabled = sw.isEnd;
    }

    if (prev) prev.addEventListener("click", function () { swiper.slidePrev(); });
    if (next) next.addEventListener("click", function () { swiper.slideNext(); });
  }
})(window, document);
